// import { Autocomplete, Backdrop, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
// import axios from "axios";
// import React, { Fragment, memo, useEffect, useRef, useState } from "react";
// import { useDispatch } from "react-redux";
// import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
// import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { useStyle } from "../style";
// import dayjs from "dayjs";
// import _ from "lodash";
// import CustomTable from "../customTable";
// import moment from "moment";
// import { Helmet } from "react-helmet-async";
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import CloseIcon from '@mui/icons-material/Close';
// import { CSVLink } from "react-csv";

// import CustomTextField from "../../../../../components/utils/input/customTextField";
// import PendingproductTable from "./pendingproducttable";
// import PendingbillTable from "./pendingbilltable";

// const StockverifyPendingReport = () => {
//     const classes = useStyle()
//     const dispatch = useDispatch();
//     const pageOption = [10, 25, 50, 100];
//     const [page, setPage] = useState(0);
//     // const [rowsPerPage, setRowsPerPage] = useState(100);
//     const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
//     // const [statusFilter, setStatusFilter] = useState("ALL");
//     const STATUS_OPTIONS = [
//   { label: "All", value: "ALL" },
//   { label: "Pending", value: "PENDING" },
//   { label: "Completed", value: "COMPLETED" }
// ];
// const [statusFilter, setStatusFilter] = useState(STATUS_OPTIONS[0]);
// const [csvData, setCsvData] = useState([]);
//     // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
//     const [pageCount, setPageCount] = useState(0);
//     const [data, setData] = useState([]);
//     const [supplier, setSupplier] = useState([]);
//     const [catData,setCatData] = useState([])
//     const [subData,setSubData] = useState([])
//     const [activeStep , setActiveStep] = useState("0")
//     const [rowData , setRowData] = useState(null)
//     const outletName = localStorage.getItem('outlet_name')
//     const [allSubData, setAllSubData] = useState([]);
// const [barcode, setBarcode] = useState("");
// const csvLinkRef = useRef(null); // ref to trigger download
//     const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
//     const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
//   const [dateLimit, setDateLimit] = useState({
//     fromDate : moment().startOf('month').format(),
//     toDate :  moment().format()
//   })
//   const [options, setOptions] = useState({
//     customer : null,
//     category : null,
//     subCategory : null
// })
// const onEdit = (e) => {
//   console.log(e.row)
//   setActiveStep("1")
//   setRowData(e.row)
// }
// function handleOptions(value, name){
//     console.log(name, value)
//     // setOptions(prev=>({...prev,[name] : value}))
//     setOptions((prev) => ({ ...prev, [name]: value }));
//         if (name === "category") {
//           setOptions((prev) => ({ ...prev, subCategory: null }));
//           filterSubCategories(value ? value.id : null);
//         }
// }
// function filterSubCategories(categoryId) {
//   if (categoryId) {
//     const filteredSubData = allSubData.filter(
//       (sub) => sub.category_id === categoryId
//     );
//     setSubData(filteredSubData);
//   } else {
//     setSubData([]);
//   }
// }
// const columns = [
//   {
//     field : 'sno',
//     headerName : 'S.no',
//     minWidth : 70,
//     maxWidth : 100,
//     headerAlign : 'center',
//     align : 'center',
//     sortable: false
//   },
//   {
//     field: "otName",
//     headerName: "Outlet Name",
//           width: 100,
//   minWidth:150,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "docno",
//     headerName: "Doc No",
//           width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "docdate",
//     headerName: "Doc Date",
//           width: 100,
//   minWidth: 200,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },


//   {
//     field: "qty",
//     headerName: "Total Qty",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "verifyqty",
//     headerName: "Verified Qty",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   {
//     field: "pendingqty",
//     headerName: "Pending Qty",
//     flex: 1,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//   },
//   // {
//   //   field: "status",
//   //   headerName: "Status",
//   //   flex: 1,
//   //   headerAlign: "center",
//   //   align: "center",
//   //   sortable: false,
//   //     renderCell: (params) => (
//   //   <span style={{ color: 'red', fontWeight: 600 }}>
//   //     {params.value}
//   //   </span>
//   // ),
//   // },
//   {
//   field: "status",
//   headerName: "Status",
//   flex: 1,
//   headerAlign: "center",
//   align: "center",
//   sortable: false,
//   renderCell: (params) => {
//     const isPending =
//       String(params.value).toLowerCase() === "pending";

//     return (
//       <span
//         style={{
//           color: isPending ? "red" : "green",
//           fontWeight: 600,
//         }}
//       >
//         {params.value}
//       </span>
//     );
//   },
// },


//   {
//     field: "view",
//     headerName: "View",
//     disableExport: true ,
//     minWidth: 130,
//     headerAlign: "center",
//     align: "center",
//     sortable: false,
//     renderCell: (params) => {
//       return (
//           <IconButton size="small" onClick={() => onEdit(params)}>
//           <VisibilityIcon sx={{fontSize: 18}} />
//         </IconButton>

//       );
//     },
//   },


// ]
// console.log(options.customer != null ? options.customer.fullname : outletName)
// // const rows = _.map(data, (val, idx) => ({
// //   id: val.docno,
// //   sno: idx + 1,
// //   otName: val.outletname || "",
// //   docno: val.docno,
// //   docdate: moment(val.docdate).format("DD-MM-YYYY"),
// //   qty: val.total_items,
// //   verifyqty: val.verified_items,
// //   pendingqty: val.pending_items,
// //   status: val.status,
// //   pendingLines: val.pending_items_lines // 🔥 important
// // }));
// const filteredData = data.filter((val) => {
//   if (statusFilter.value === "ALL") return true;
//   return val.status === statusFilter.value;
// });

// // const rows = _.map(data, (val, idx) => ({
//   const rows = _.map(filteredData, (val, idx) => ({
//   id: val.id, 
//   sno: idx + 1,
//   otName: val.outletname || "",
//   docno: val.docno,
//   docdate: moment(val.docdate).format("DD-MM-YYYY"),
//   qty: val.total_items,
//   verifyqty: val.verified_items,
//   pendingqty: val.pending_items,
//   status: val.status,
//   pendingLines: val.pending_items_lines
// }));

// const props = {
//   columns : columns,
//   rows : rows,
//   page: page,
//   setPage: setPage,
//   rowsPerPage: rowsPerPage,
//   setRowsPerPage: setRowsPerPage,
//   pageCount: pageCount,
//   pageOption: pageOption,
//   totalAmount:totalAmount,
//   totalFlag:totalFlag,

// }
// // useEffect(() => {
// //   // Calculate total balance amount
// //   setTotalFlag(true)
// //   let total = 0;

// //   data.forEach(val => {
// //       total += parseFloat(val.amount);
// //   });
// //   setTotalAmount(total.toFixed(0));
// // }, [data]);
// useEffect(() => {
//   setTotalFlag(true);

//   // total rows in current page
//   const total = rows.length;

//   setTotalAmount(total);
// }, [rows]);

//   function handleChange(e, name) {
//     setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
//   }
//   function getSupplierData() {
//     axios
//       .get("/v1/outlet/list/1")
//       .then((res) => {
//         console.log(res.data)
//         setSupplier(res.data);
//       })
//       .catch((err) => {
//         setData([]);
//         setRowData(null);
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }
//   function getCategory(){
//     axios.get('/v1/categories')
//     .then(res=>{
//         // _.filter(res.data, val=>{
//         //     if(val.is_active){
//         //          setCatData(res.data)
//         //     }
//         // })
//         const activeCats = res.data.filter(val => val.is_active);
// setCatData(activeCats);

//     })
//     .catch(err=>{
//       setData([]);
//       setRowData(null);
//         console.log(err)
//         dispatch(setSnackbar(true,'error',err.response.data.error))
//     })
// }

// function getSubCategory(){
//     axios.get('/v1/subcategories')
//     .then(res=>{
//             // setSubData(res.data)
//             setAllSubData(res.data);
//     })
//     .catch(err=>{
//         console.log(err)
//         setData([]);
//         setRowData(null);
//         dispatch(setSnackbar(true,'error',err.response.data.error))
//     })
// }

// function handleOutletSalesItemWise() {
//   if(!options.customer){
//     dispatch(setSnackbar(
//         true,
//         "error",
//         "Select the outlet"
//       ));

//   }
//   setData([]);
//   setRowData(null);
//   const postData = {
//     from_date: moment(dateLimit.fromDate).format("YYYY-MM-DD"),
//     to_date: moment(dateLimit.toDate).format("YYYY-MM-DD"),
//     // customer: options.customer?.id || 0,
//     //    category_name: options.category
//     //   ? options.category.category_name
//     //   : "",

//     // subcategory_name: options.subCategory
//     //   ? options.subCategory.subcategory_name
//     //   : "",
//     outlet_id:options.customer?.id || 0,
//       page: page + 1,        // API is 1-based
//   page_size: rowsPerPage
//     //  barcode: barcode || "", 
//   };
//   axios.get( `/v1/stock_verify/pending_verification_report/` +
//   `${moment(dateLimit.fromDate).format("YYYY-MM-DD")}/` +
//   `${moment(dateLimit.toDate).format("YYYY-MM-DD")}/` +
//   `${options.customer?.id || 0}/` +
//   `${rowsPerPage}/` +
//   `${page + 1}`)

//   // axios.post("/v1/stock_verify/pending_verification_report", postData)
// .then(res => {
//   setData(res.data.data || []);
//   // setPageCount(res.data.meta?.pagination?.total || 0);
//   setPageCount(res.data.meta.pagination.total_pages);


//   setTotalAmount(res.data.grandTotal || 0);
//   setTotalFlag(true);
// })


//     .catch(err => {
//       setData([]);
//       setRowData(null);


//       // setDateLimit({fromDate:"",toDate:""})

//       // dispatch(setSnackbar(
//       //   true,
//       //   "error",
//       //   err.response?.data?.errors?.[0]?.message || "Something went wrong"
//       // ));
//     });
// }
// // const generateCSVData = () => {
// //   const csvData = [
// //     [
// //       "S.no",
// //       "Outlet Name",
// //       "Doc No",
// //       "Doc Date",
// //       "Product Barcode",
// //       "Product Name",
// //       "Description",
// //       "Qty",
// //       "Rate",
// //       "Amount",
// //       "Stock Status"
// //     ]
// //   ];

// //   let sno = 1;

// //   data.forEach((doc) => {
// //     if (Array.isArray(doc.pending_items_lines)) {
// //       doc.pending_items_lines.forEach((line) => {
// //         csvData.push([
// //           sno++,
// //           doc.outletname,
// //           doc.docno,
// //           moment(doc.docdate).format("DD-MM-YYYY"),
// //           line.barcode,
// //           line.pro_name,
// //           line.description,
// //           line.qty,
// //           line.rate,
// //           line.amount,
// //           line.stock_status
// //         ]);
// //       });
// //     }
// //   });

// //   return csvData;
// // };


// const handleDownloadCSV = async () => {
//   if (!options.customer || options.customer.id === 0) {
//     dispatch(
//       setSnackbar(true, "error", "Please select an outlet before downloading CSV")
//     );
//     return;
//   }

//   try {
//     const res = await axios.get(
//       `/v1/stock_verify/pending_verification_download/${moment(
//         dateLimit.fromDate
//       ).format("YYYY-MM-DD")}/${moment(dateLimit.toDate).format(
//         "YYYY-MM-DD"
//       )}/${options.customer.id}`
//     );

//     const apiData = res.data?.data || [];
//     let sno = 1;

//     const dataForCSV = [
//       [
//         "S.no",
//         "Outlet Name",
//         "Doc No",
//         "Doc Date",
//         "Product Barcode",
//         "Product Code",
//         "Product Name",
//         "Rate",
//         "MRP",
//       ],
//     ];

//     apiData.forEach((doc) => {
//       if (Array.isArray(doc.pending_items)) {
//         doc.pending_items.forEach((item) => {
//           dataForCSV.push([
//             sno++,
//             doc.outletname,
//             doc.docno,
//             moment(doc.docdate).format("DD-MM-YYYY"),
//             item.barcode,
//             item.pro_code,
//             item.pro_name,
//             item.amount,
//             item.mrp,
//           ]);
//         });
//       }
//     });

//     setCsvData(dataForCSV);

//     // trigger download
//     setTimeout(() => {
//       csvLinkRef.current.link.click();
//     });
//   } catch (error) {
//     console.error(error);
//     dispatch(setSnackbar(true, "error", "Failed to download CSV"));
//   }
// };

// useEffect(() => {
//     getSupplierData();
//     getCategory()
//     getSubCategory()
//   }, []);

//   useEffect(() => {
//     if (dateLimit.fromDate && dateLimit.toDate) {
//       handleOutletSalesItemWise();
//     }
//   }, [
//     page,
//     rowsPerPage,
//     dateLimit.fromDate,
//     dateLimit.toDate,
//     options.customer,
//     options.category,
//     options.subCategory,
//       barcode,
//   ]);

//   console.log(rows,"datadata");


//   return (
//   <Fragment>
//     <Helmet><title>Stock Verify Pending Barcode Report</title></Helmet>
//    <Typography variant="h6">Stock Verify Pending Barcode Report</Typography>
//       <Grid container spacing={2} className="p-2 pt-2">
//         <Grid item md={3}>
//           <Autocomplete 
//             size="small"
//             options={[{id:0 , fullname :"All"} , ...supplier]}
//             onChange={(e,value)=>handleOptions(value,'customer')}
//             getOptionLabel={option=>option.fullname}
//             renderInput={(params) => <TextField {...params} label="Select Outlet"/>}
//           />
//         </Grid>
//                <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "fromDate")}
//               value={dayjs(dateLimit.fromDate)}
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'From',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid>
//            <Grid item md={3}>
//           <LocalizationProvider dateAdapter={AdapterDayjs}>
//             <DatePicker
//               onChange={(e) => handleChange(e, "toDate")}
//               value={dayjs(dateLimit.toDate)}
//               format='DD-MM-YYYY'
//               slotProps={{
//                 textField: {
//                   size: "small",
//                   label:'To',
//                   style:{width : '100%'}
//                 },
//               }}
//             />
//           </LocalizationProvider>
//         </Grid>
//         <Grid item md={3}>
//   <Autocomplete
//     size="small"
//     options={STATUS_OPTIONS}
//     value={statusFilter}
//     onChange={(e, val) =>
//       setStatusFilter(val || STATUS_OPTIONS[0])
//     }
//     getOptionLabel={(option) => option.label}
//     isOptionEqualToValue={(opt, val) =>
//       opt.value === val.value
//     }
//     renderInput={(params) => (
//       <TextField {...params} label="Status" />
//     )}
//   />
// </Grid>



//         {/* <Grid item md={3}>
//             <CSVLink data={generateCSVData()} filename={"StockVerificationPendingBarcode_Reports.csv"}>
//             <Button variant="contained" color="primary">
//               Download CSV
//             </Button>
//           </CSVLink>
//         </Grid> */}
//         <Grid item md={3}>
//   <Button
//     variant="contained"
//     color="primary"
//     onClick={handleDownloadCSV}
//   >
//     Download CSV
//   </Button>

//   {/* hidden CSVLink to trigger download */}
//   <CSVLink
//     data={csvData}
//     filename={`StockVerificationPendingBarcode_${moment().format("YYYYMMDD_HHmm")}.csv`}
//     className="hidden"
//     ref={csvLinkRef}
//   />
// </Grid>

//         <Grid item md={3}>

//         </Grid>
//         {/* <Grid item md={3} style={{ display: 'flex', alignItems: 'start',justifyContent:"end" }}>
//           <CSVLink data={generateCSVData()} filename={"StockVerificationMismatch_Reports.csv"}>
//             <Button variant="contained" color="primary">
//               Download CSV
//             </Button>
//           </CSVLink>
//         </Grid> */}
//       </Grid>
//       {activeStep === "0" ? 
//        <PendingbillTable props={props}/> 
//       //  <CustomTable props={props}/> 

//        : 
//        <Grid>
//         <PendingproductTable setActiveStep={setActiveStep} options={options} setOptions={setOptions} dateLimit={dateLimit} setDateLimit={setDateLimit} rowData={rowData}/>
//        </Grid>
//        }
//   </Fragment>
//   )
// }

// export default memo(StockverifyPendingReport)

//02-03-25

import { Autocomplete, Backdrop, Button, Grid, IconButton, TextField, Typography } from "@mui/material";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import axios from "axios";
import React, { Fragment, memo, useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { setSnackbar } from "../../../../../components/hooks/snackBar/reducers";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import CustomTable from "../customTable";
import moment from "moment";
import { Helmet } from "react-helmet-async";
import VisibilityIcon from '@mui/icons-material/Visibility';
import CloseIcon from '@mui/icons-material/Close';
import { CSVLink } from "react-csv";
import CustomTextField from "../../../../../components/utils/input/customTextField";
import PendingproductTable from "./pendingproducttable";
import PendingbillTable from "./pendingbilltable";

const StockverifyPendingReport = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const STATUS_OPTIONS = [
    { label: "All", value: "ALL" },
    { label: "Pending", value: "PENDING" },
    { label: "Completed", value: "COMPLETED" }
  ];
  const [statusFilter, setStatusFilter] = useState(STATUS_OPTIONS[0]);
  const [isOutletLoading, setIsOutletLoading] = useState(true);
  const [csvData, setCsvData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const [catData, setCatData] = useState([])
  const [subData, setSubData] = useState([])
  const [rowData, setRowData] = useState(null)
  const outletName = localStorage.getItem('outlet_name')
  const [allSubData, setAllSubData] = useState([]);
  const [barcode, setBarcode] = useState("");
  const csvLinkRef = useRef(null);
  const [totalAmount, setTotalAmount] = useState(0)
  const [totalFlag, setTotalFlag] = useState(false)
  const [dateLimit, setDateLimit] = useState({
    fromDate: moment().startOf('month').format(),
    toDate: moment().format()
  })
  const [options, setOptions] = useState({
    customer: null,
    category: null,
    subCategory: null
  })

  // Dialog state
  const [dialogOpen, setDialogOpen] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);

  // const onEdit = (e) => {
  //   console.log(e.row)
  //   setRowData(e.row);
  //   setDialogOpen(true);
  // }
  const onEdit = (params) => {
    console.log(params.row)
    setRowData(params.row);
    setDialogOpen(true);
  };


  const handleDialogClose = () => {
    setDialogOpen(false);
    setRowData(null);
  };

  function handleOptions(value, name) {
    console.log(name, value)
    setOptions((prev) => ({ ...prev, [name]: value }));
    if (name === "category") {
      setOptions((prev) => ({ ...prev, subCategory: null }));
      filterSubCategories(value ? value.id : null);
    }
  }

  function filterSubCategories(categoryId) {
    if (categoryId) {
      const filteredSubData = allSubData.filter(
        (sub) => sub.category_id === categoryId
      );
      setSubData(filteredSubData);
    } else {
      setSubData([]);
    }
  }

  const columns = [
    {
      field: 'sno',
      headerName: 'S.no',
      minWidth: 70,
      maxWidth: 100,
      headerAlign: 'center',
      align: 'center',
      sortable: false
    },
    {
      field: "otName",
      headerName: "Outlet Name",
      width: 100,
      minWidth: 150,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "docno",
      headerName: "Doc No",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "docdate",
      headerName: "Doc Date",
      width: 100,
      minWidth: 200,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },

    {
      field: "qty",
      headerName: "Total Qty",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "verifyqty",
      headerName: "Verified Qty",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "pendingqty",
      headerName: "Pending Qty",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        const isPending =
          String(params.value).toLowerCase() === "pending";

        return (
          <span
            style={{
              color: isPending ? "red" : "green",
              fontWeight: 600,
            }}
          >
            {params.value}
          </span>
        );
      },
    },

    {
      field: "view",
      headerName: "View",
      disableExport: true,
      minWidth: 130,
      headerAlign: "center",
      align: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <IconButton size="small" onClick={() => onEdit(params)}>
            <VisibilityIcon sx={{ fontSize: 18 }} />
          </IconButton>

        );
      },
    },
  ]

  const filteredData = data.filter((val) => {
    if (statusFilter.value === "ALL") return true;
    return val.status === statusFilter.value;
  });

  const rows = _.map(filteredData, (val, idx) => ({
    id: val.id,
    sno: idx + 1,
    otName: val.outletname || "",
    docno: val.docno,
    docdate: moment(val.docdate).format("DD-MM-YYYY"),
    qty: val.total_items,
    verifyqty: val.verified_items,
    pendingqty: val.pending_items,
    status: val.status,
    pendingLines: val.pending_items_lines
  }));

  const props = {
    columns: columns,
    rows: rows,
    page: page,
    setPage: setPage,
    rowsPerPage: rowsPerPage,
    setRowsPerPage: setRowsPerPage,
    pageCount: pageCount,
    totalPages: totalPages,
    pageOption: pageOption,
    totalAmount: totalAmount,
    totalFlag: totalFlag,
    loading: loading,
  }

  useEffect(() => {
    setTotalFlag(true);
    const total = rows.length;
    setTotalAmount(total);
  }, [rows]);

  function handleChange(e, name) {
    setDateLimit(prev => ({ ...prev, [name]: dayjs(e).format() }))
  }

  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        console.log(res.data)
        setSupplier(res.data);
        const loggedOutletName = localStorage.getItem('outlet_name');
        const userOutlet = res.data.find(outlet => outlet.fullname === loggedOutletName);
        if (userOutlet) {
          setOptions(prev => ({ ...prev, customer: userOutlet }));
        }
        setIsOutletLoading(false);
      })
      .catch((err) => {
        setData([]);
        setRowData(null);
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }

  function getCategory() {
    axios.get('/v1/categories')
      .then(res => {
        const activeCats = res.data.filter(val => val.is_active);
        setCatData(activeCats);
      })
      .catch(err => {
        setData([]);
        setRowData(null);
        console.log(err)
        dispatch(setSnackbar(true, 'error', err.response.data.error))
      })
  }

  function getSubCategory() {
    axios.get('/v1/subcategories')
      .then(res => {
        setAllSubData(res.data);
      })
      .catch(err => {
        console.log(err)
        setData([]);
        setRowData(null);
        dispatch(setSnackbar(true, 'error', err.response.data.error))
      })
  }

  //   function handleOutletSalesItemWise() {
  //     // if(!options.customer){
  //     //   dispatch(setSnackbar(
  //     //       true,
  //     //       "error",
  //     //       "Select the outlet"
  //     //     )); 
  //     // }
  //     if (isOutletLoading || (!options.customer || options.customer.id === undefined)) {
  //   dispatch(setSnackbar(
  //     true,
  //     "error",
  //     "Select the outlet"
  //   ));
  //   return;  // ADD return to skip API call
  // }
  //     setData([]);
  //     setRowData(null);
  //     axios.get( `/v1/stock_verify/pending_verification_report/` +
  //     `${moment(dateLimit.fromDate).format("YYYY-MM-DD")}/` +
  //     `${moment(dateLimit.toDate).format("YYYY-MM-DD")}/` +
  //     `${options.customer?.id || 0}/` +
  //     `${rowsPerPage}/` +
  //     `${page + 1}`)
  //   .then(res => {
  //     setData(res.data.data || []);
  //     setPageCount(res.data.meta.pagination.total_pages);
  //     setTotalAmount(res.data.grandTotal || 0);
  //     setTotalFlag(true);
  //   })
  //   .catch(err => {
  //     setData([]);
  //     setRowData(null);
  //   });
  //   }
  //   function handleOutletSalesItemWise() {
  //   if (isOutletLoading || (!options.customer || options.customer.id === undefined)) {
  //     return;
  //   }

  //   // if (!options.customer.id) {
  //   //   dispatch(setSnackbar(true, "error", "Select the outlet"));
  //   //   return;
  //   // }
  //   if (
  //   !options.customer ||
  //   options.customer.id === undefined ||
  //   options.customer.id === null
  // ) {
  //   dispatch(setSnackbar(true, "error", "Select the outlet"));
  //   return;
  // }
  //   setData([]);
  //   setRowData(null);
  //   axios.get( `/v1/stock_verify/pending_verification_report/` +
  //   `${moment(dateLimit.fromDate).format("YYYY-MM-DD")}/` +
  //   `${moment(dateLimit.toDate).format("YYYY-MM-DD")}/` +
  //   `${options.customer.id}/` +  // id:0 = All outlets
  //   `${rowsPerPage}/` +
  //   `${page + 1}`)
  //   .then(res => {
  //     setData(res.data.data || []);
  //     // setPageCount(res.data.meta.pagination.total_pages);
  //      // Total records
  //   setPageCount(
  //     res.data.meta?.pagination?.total || 0
  //   );

  //   // Total pages
  //   setTotalPages(
  //     res.data.meta?.pagination?.total_pages || 0
  //   );
  //     setTotalAmount(res.data.grandTotal || 0);
  //     setTotalFlag(true);
  //   })
  //   .catch(err => {
  //     setData([]);
  //     setRowData(null);
  //   });
  // }
  function handleOutletSalesItemWise() {
    if (isOutletLoading || (!options.customer || options.customer.id === undefined)) {
      return;
    }

    setLoading(true); // START LOADER
    setData([]);
    setRowData(null);

    axios.get(
      `/v1/stock_verify/pending_verification_report/` +
      `${moment(dateLimit.fromDate).format("YYYY-MM-DD")}/` +
      `${moment(dateLimit.toDate).format("YYYY-MM-DD")}/` +
      `${options.customer.id}/` +
      `${rowsPerPage}/` +
      `${page + 1}`
    )
      .then(res => {
        setData(res.data.data || []);

        setPageCount(
          res.data.meta?.pagination?.total || 0
        );

        setTotalPages(
          res.data.meta?.pagination?.total_pages || 0
        );

        setTotalAmount(res.data.grandTotal || 0);
        setTotalFlag(true);
      })
      .catch(err => {
        setData([]);
        setRowData(null);
      })
      .finally(() => {
        setLoading(false); // STOP LOADER
      });
  }

  const handleDownloadCSV = async () => {
    // if (!options.customer || options.customer.id === 0) {
    //   dispatch(
    //     setSnackbar(true, "error", "Please select an outlet before downloading CSV")
    //   );
    //   return;
    // }
    if (!options.customer || options.customer.id === undefined) {
      dispatch(
        setSnackbar(true, "error", "Please select an outlet before downloading CSV")
      );
      return;
    }

    try {
      const res = await axios.get(
        `/v1/stock_verify/pending_verification_download/${moment(
          dateLimit.fromDate
        ).format("YYYY-MM-DD")}/${moment(dateLimit.toDate).format(
          "YYYY-MM-DD"
        )}/${options.customer.id}`
      );

      const apiData = res.data?.data || [];
      let sno = 1;

      const dataForCSV = [
        [
          "S.no",
          "Outlet Name",
          "Doc No",
          "Doc Date",
          "Product Barcode",
          "Product Code",
          "Product Name",
          "Rate",
          "MRP",
        ],
      ];

      apiData.forEach((doc) => {
        if (Array.isArray(doc.pending_items)) {
          doc.pending_items.forEach((item) => {
            dataForCSV.push([
              sno++,
              doc.outletname,
              doc.docno,
              moment(doc.docdate).format("DD-MM-YYYY"),
              item.barcode,
              item.pro_code,
              item.pro_name,
              item.amount,
              item.mrp,
            ]);
          });
        }
      });

      setCsvData(dataForCSV);

      setTimeout(() => {
        csvLinkRef.current.link.click();
      });
    } catch (error) {
      console.error(error);
      dispatch(setSnackbar(true, "error", "Failed to download CSV"));
    }
  };

  useEffect(() => {
    getSupplierData();
    getCategory()
    getSubCategory()
  }, []);

  useEffect(() => {
    if (dateLimit.fromDate && dateLimit.toDate) {
      handleOutletSalesItemWise();
    }
  }, [
    page,
    rowsPerPage,
    dateLimit.fromDate,
    dateLimit.toDate,
    options.customer,
    options.category,
    options.subCategory,
    barcode,
  ]);

  console.log(rows, "datadata");


  return (
    <Fragment>
      <Helmet><title>Stock Verify Pending Barcode Report</title></Helmet>
      <Typography variant="h6">Stock Verify Pending Barcode Report</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete
            size="small"
            options={[{ id: 0, fullname: "All" }, ...supplier]}
            value={options.customer || null}
            onChange={(e, value) => handleOptions(value, 'customer')}
            getOptionLabel={option => option.fullname}
            renderInput={(params) => <TextField {...params} label="Select Outlet" />}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label: 'From',
                  style: { width: '100%' }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label: 'To',
                  style: { width: '100%' }
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <Autocomplete
            size="small"
            options={STATUS_OPTIONS}
            value={statusFilter}
            onChange={(e, val) =>
              setStatusFilter(val || STATUS_OPTIONS[0])
            }
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(opt, val) =>
              opt.value === val.value
            }
            renderInput={(params) => (
              <TextField {...params} label="Status" />
            )}
          />
        </Grid>

        <Grid item md={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleDownloadCSV}
          >
            Download CSV
          </Button>

          {/* hidden CSVLink to trigger download */}
          <CSVLink
            data={csvData}
            filename={`StockVerificationPendingBarcode_${moment().format("YYYYMMDD_HHmm")}.csv`}
            className="hidden"
            ref={csvLinkRef}
          />
        </Grid>

        <Grid item md={3}>

        </Grid>
      </Grid>

      {/* Main table - always visible */}
      <PendingbillTable props={props} />

      {/* Dialog for product details */}
      <Dialog
        fullWidth
        maxWidth="xl"
        open={dialogOpen}
        onClose={handleDialogClose}
        hideBackdrop
        PaperProps={{
          sx: { height: '90vh' }
        }}
      >
        <DialogTitle>
          Pending Products - {rowData?.docno || ''}
          <IconButton
            onClick={handleDialogClose}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 0, height: '100%' }}>
          <PendingproductTable
            options={options}
            setOptions={setOptions}
            dateLimit={dateLimit}
            setDateLimit={setDateLimit}
            rowData={rowData}
            onClose={handleDialogClose}
            hideBackButton={true}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  )
}

export default memo(StockverifyPendingReport);
